import React, { Component } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import PageAuthorize from '../../../../security/PageAuthorize';
import EtelAPI from '../../../../api/EtelAPI';
import Alerts from '../../../../prototypes/Alerts';
import { clearUserProfile } from '../../../../redux/actions/user';
import { clearBugsnagUser } from '../../../../redux/actions/bugsnag';
import RouteTitle from '../../../../presentation/RouteTitle';
import { Dialog, DialogHeader, DialogBody, DialogFooter } from '../../../../presentation/Dialog';

class DialerDetectionExamplesDialog extends Component {
  constructor( props ) {
    super( props );

    this.examplespath = '/vfiles/examples/'

    // States
    this.state = {
      show: props.show === undefined ? false : props.show,
      examples: [],
      filteredExamples: [],
      filterValue: 'none'
    };

    // Dialog Events
    this.onClose = this.onClose.bind( this );
    this.onDelete = this.onDelete.bind( this );

    // Bind Events
    this.onHandleException = this.onHandleException.bind( this );
    this.doLogOff = this.doLogOff.bind( this );
    this.onHandleChange = this.onHandleChange.bind( this );
  }

  componentDidMount() {
    this.getExamples().then( ( result ) => {
      let examples = result.map( ( example ) => {
        return example;
      } );

      this.setState( {
        examples: examples,
      } );
    } ).catch( ( exception ) => {
      this.onHandleException( exception );
    } );
  }

  componentWillReceiveProps( nextProps ) {
    if( this.compareProps( this.props, nextProps ) === true ) {
      this.setState( {
        show: nextProps.show === undefined ? false : nextProps.show
      });
    }
  }

  compareProps( props, nextProps ) {

    if( props.show !== nextProps.show ) {
      return true;
    }

    return false;
  }

  doLogOff() {
    const { dispatch } = this.props;
    const auth = this.props.auth;
    const history = this.props.history;
    auth.logout();
    dispatch( clearBugsnagUser() );
    dispatch( clearUserProfile() );
    history.push( '/login ');
  }

  onHandleException( e ) {
    let section = { title: 'Dialer Detection Examples' };
    const bugsnag = this.props.bugsnag;
    const { dispatch } = this.props;
    const alerts = new Alerts( bugsnag, dispatch );
    const status = e.status === undefined ? 0 : e.status;
    if (status === 410 ) {
      alerts.INFO( section.title, 'Your session has expired.', 5000 );
      this.doLogOff();
    } else if ( status === 500 ) {
      alerts.INFO( section.title, e.statusText, 5000 );
    } else {
      if( e.statusText !== undefined ) {
        alerts.CRITICAL( section.title, e, false );
      } else {
        alerts.CRITICAL( section.title, e );
      }
    }
  }

  /**
   * Close event for the dialog.
   *
   * @param {event} e
   */
  onClose( e ) {
    if( this.props.onClose !== undefined ) {
      this.setState( {
        filterValue: 'none',
        filteredExamples: []
      } );
      this.props.onClose( e );
    } else {
      this.setState( {
        show: false
      } );
    }
  }

  /**
   * Retrieves the rows where SaveAsExample = 1 and InExamples = 1.
   */
  getExamples() {
    return new Promise((resolve, reject) => {
      let api = new EtelAPI('dialerdetection/examples');

      if (api !== undefined) {
        api.get([{ SaveAsExample: 1 }, { InExamples: 1 }]).then((results) => {
          resolve(results);
        }).catch((exception) => {
          reject(exception);
        });
      }
    });
  }

  /**
   * Removes the audio file from the examples.
   */
  onDelete(muuid) {
    // Example to update
    const toUpdate = this.state.examples.filter((example) => {
      return example['M_UUID'] === muuid;
    })[0];

    // Parameters to be updated
    const message = {
      M_UUID: muuid,
      DialerValidated: toUpdate['DialerValidated'],
      DialerNotes: toUpdate['DialerNotes'],
      SaveAsExample: 0
    };

    // Connection to make the update
    const api = new EtelAPI('dialerdetection');

    api.update(message).then((result) => {
      // Remove the example from the array to update state
      const examples = this.state.examples.filter((example) => {
        return example['M_UUID'] !== toUpdate['M_UUID']
      });

      this.setState({
        examples: examples
      });
    }).catch((error) => {
      let exception = { statusText: 'Failed to remove the audio file.' };
      this.onHandleException(exception);
    });
  }

  /**
   * Handles the change event for the dropdown to filter by dialer notes.
   *
   * @param {event} event
   */
  onHandleChange(event) {
    const filteredExamples = this.state.examples.filter((example) => {
      return example['DialerNotes'] === event.target.value;
    });

    this.setState({
      filteredExamples: filteredExamples,
      filterValue: event.target.value
    });
  }

  /**
   * Renders the header.
   */
  onRenderHeader() {
    return <DialogHeader caption={'Dialer Detection Example Audio Files'} closeButton onClose={this.onClose} />
  }

  /**
   * Renders the body.
   */
  onRenderBody() {
    // Example audio files to render
    const examples = (this.state.filteredExamples.length > 0
      ? this.state.filteredExamples
      : this.state.examples)
      .map((example) => {
        const muuid = example['M_UUID'];
        const dialerNotes = example['DialerNotes'];

        return (
          <div key={muuid} className='dialer-detection-examples-row'>
            <div className='dialer-detection-examples-body-item-1'>{muuid + '.mp3'}</div>
            <div className='dialer-detection-examples-body-item-2'>{dialerNotes}</div>
            <div className='dialer-detection-examples-body-item-3'>{example['DialerValidateDate']}</div>
            <div className='dialer-detection-examples-body-item-4'>
              <audio controls src={this.examplespath + muuid + '.mp3'}>
                Your browser does not support the <code>audio</code> element.
              </audio>
            </div>
            <div className='dialer-detection-examples-body-item-5 dialer-detection-examples-delete'>
              <i className="icon-fontello-trash-1" style={{'color': 'red', 'cursor': 'pointer'}} onClick={() => this.onDelete(muuid)} />
            </div>
          </div>
        );
      });

    // Unique options to filter by dialer notes
    const uniqueOptions = Array.from(new Set(this.state.examples.map((example) => {
      return example['DialerNotes'];
    }))).sort().map((option) => {
      return <option key={option} value={option}>{option}</option>
    });

    return (
      <DialogBody>
        <div className="dialer-detection-example-container">
          <div className='dialer-detection-examples-filter'>
            <div className='dialer-detection-examples-filter-item-1'>
              <label>Filter: </label>
            </div>
            <div className='dialer-detection-examples-filter-item-2'>
              <select value={this.state.filterValue} onChange={this.onHandleChange} className='dialer-detection-examples-select'>
                <option value='none'>No Filter</option>
                {uniqueOptions}
              </select>
            </div>
          </div>
          <div className='dialer-detection-examples-header'>
            <div className='dialer-detection-examples-header-items-1'>Audio File</div>
            <div className='dialer-detection-examples-header-items-2'>Audio Notes</div>
            <div className='dialer-detection-examples-header-items-3'>Date Validated</div>
            <div className='dialer-detection-examples-header-items-4'>Audio Sample</div>
            <div className='dialer-detection-examples-header-items-5'><i className="icon-fontello-trash-1" /></div>
          </div>
          <div className="dialer-detection-examples-body">
            {examples}
          </div>
        </div>
      </DialogBody>
    );
  }

  /**
   * Renders the footer.
   */
  onRenderFooter() {
    return (
      <DialogFooter>
        <button style={{'width': '120px'}} className='dialer-detection-users-button' onClick={this.onClose}>
          Close
        </button>
      </DialogFooter>
    );
  }

  render() {
    return (
      <PageAuthorize groups={['Administrators', 'Operations', 'Management', 'Interns']}>
        <RouteTitle title={'Dialer Detection - Example Audio Files'} />
        <Dialog show={this.state.show} width={80} height={80} onClose={this.onClose}>
          {this.onRenderHeader()}
          {this.onRenderBody()}
          {this.onRenderFooter()}
        </Dialog>
      </PageAuthorize>
    );
  }
}

export default withRouter(
  connect(
    ( store ) => {
      return {
        auth: store.auth.auth,
        bugsnag: store.bugsnag.Bugsnag,
        user: store.user.user
      };
    }
  )( DialerDetectionExamplesDialog ) );


// WEBPACK FOOTER //
// ./src/content/enterprise/dialerdetection/components/DialerDetectionExamplesDialog.js